import { Injectable, OnDestroy } from '@angular/core';

import { EventBridge, IframeService } from '@payments/ngpgcard-utils';

@Injectable({
    providedIn: 'root',
})
export class CardIframeService implements OnDestroy {
    private iframeService: IframeService | null;
    public eventBridge: EventBridge | null;

    constructor() {}

    initializeServices() {
        this.iframeService = new IframeService();
        this.eventBridge = new EventBridge();
    }

    public _iframeService() {
        return this.iframeService;
    }

    public _eventBridge() {
        return this.eventBridge;
    }

    ngOnDestroy() {
        this.destroyServices();
    }

    private destroyServices() {
        // Add any necessary cleanup logic here
        this.iframeService = null;
        this.eventBridge = null;
    }

    public initialize() {
        this.destroyServices();
        this.initializeServices();
    }
}
